<template>
  <main id="logout">
    <h1 class="pt-4 mb-3">ご利用ありがとうございました。</h1>
    <a v-if="isTokenExist" class="body-1" :href="printLoginUrl">ログイン画面に戻る</a>
  </main>
</template>

<script>
export default {
  name: 'logout',
  components: {
  },
  data () {
    return {
      store: {
        lit: ''
      }
    }
  },
  mounted () {
    this.logout()
  },
  methods: {
    logout: function () {
      const jwt = this.$localStorage.get('jwt')
      if (jwt && jwt !== 'undefined') {
        this.$set(this.store, 'lit', this.$localStorage.get('lit'))
        this.$localStorage.remove('lit')
        this.$localStorage.remove('jwt')
        this.$store.commit('loader/close')
      } else {
        this.$router.push('503')
      }
    }
  },
  computed: {
    isTokenExist () {
      return !!this.store.lit
    },
    printLoginUrl () {
      return `/login?t=${this.store.lit}`
    }
  }
}
</script>
